<template>
  <section class="sala-agenda-view sala-agenda-view--porta" :class="{ 'sala-agenda-view--imersivo': imersivoCss }"
    :aria-label="agendaQueryOk ? `Agenda — ${tituloSala}` : 'Agenda de sala'">
    <button v-if="imersivoCss" type="button" class="sala-agenda-btn-sair-imersivo" aria-label="Sair da tela cheia"
      @click="sairImersivoCss">
      Sair
    </button>
    <div class="sala-porta-body">
      <div v-if="!agendaQueryOk" class="sala-porta-panel sala-porta-panel--alert">
        <p class="sala-porta-panel-title">Parâmetros da URL</p>
        <p>
          Abra esta página com o <strong>token do display</strong> da sala (gerado no backend),
          por exemplo:
        </p>
        <pre class="sala-porta-pre">{{ exemploUrl }}</pre>
      </div>

      <div v-else-if="erroGoogle" class="sala-porta-panel sala-porta-panel--alert">
        <p class="sala-porta-panel-title">Google não conectado</p>
        <p>
          A conta de serviço deste display não tem Google Calendar vinculado.
          Conecte o Google nesse usuário no portal e tente novamente.
        </p>
      </div>

      <div v-else-if="erroToken" class="sala-porta-panel sala-porta-panel--alert">
        <p class="sala-porta-panel-title">Token inválido</p>
        <p>{{ erro || "O token deste display é inválido ou foi desativado." }}</p>
      </div>

      <div v-else-if="carregando && !dadosCarregados" class="sala-porta-panel sala-porta-panel--loading">
        <i class="fas fa-spinner fa-spin sala-porta-spin" aria-hidden="true"></i>
        <span>Carregando agenda…</span>
      </div>

      <div v-else-if="erro" class="sala-porta-panel sala-porta-panel--alert">
        {{ erro }}
      </div>

      <template v-else-if="agendaQueryOk">
        <div class="sala-agenda-surface">
          <div class="sala-agenda-grade-wrap sala-agenda-grade-wrap--porta">
            <div class="sala-agenda-semana-header" role="banner">
              <div class="sala-agenda-header-lead">
                <img class="sala-agenda-header-logo" :src="logoAgendaHeader" alt="Thalamus" decoding="async" />
                <div class="sala-agenda-header-lead-fill" aria-hidden="true" />
              </div>
              <h1 class="sala-agenda-sala-titulo" :title="tituloSala">{{ tituloSala }}</h1>
              <div class="sala-agenda-header-aside">
                <div class="sala-agenda-visao-btns sala-agenda-visao-btns--compacto" role="group"
                  aria-label="Tipo de visualização da agenda">
                  <button type="button" class="sala-agenda-visao-btn"
                    :class="{ 'sala-agenda-visao-btn--ativo': visualizacao === 'dia' }"
                    :aria-pressed="visualizacao === 'dia'" @click="definirVisualizacao('dia')">
                    Dia
                  </button>
                  <button type="button" class="sala-agenda-visao-btn"
                    :class="{ 'sala-agenda-visao-btn--ativo': visualizacao === 'semana' }"
                    :aria-pressed="visualizacao === 'semana'" @click="definirVisualizacao('semana')">
                    Semana
                  </button>
                </div>
                <div class="sala-agenda-header-aside-inner">
                  <time class="sala-agenda-relogio" :datetime="agoraDatetimeISO" :title="relogioTituloTooltip">
                    <span class="sala-agenda-relogio-data">{{ relogioDataCabecalho }}</span>
                    <span class="sala-agenda-relogio-hora">{{ relogioHoraCabecalho }}</span>
                  </time>
                  <button v-if="mostrarBotaoTelaCheia" type="button" class="sala-agenda-btn-fullscreen"
                    aria-label="Tela cheia" title="Tela cheia" @click="entrarTelaCheia">
                    <i class="fas fa-expand" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div v-if="salaStatusUi" class="sala-agenda-status-porta" :class="'sala-agenda-status-porta--' + salaStatusUi.codigo"
              role="status" aria-live="polite">
              <span class="sala-agenda-status-ico" aria-hidden="true">
                <i :class="['fas', salaStatusUi.icone]"></i>
              </span>
              <div class="sala-agenda-status-copy">
                <span class="sala-agenda-status-titulo">{{ salaStatusUi.rotulo }}</span>
                <span class="sala-agenda-status-detalhe">{{ salaStatusUi.detalhe }}</span>
              </div>
            </div>
            <div class="sala-agenda-grade-main sala-agenda-grade-main--porta"
              :class="{ 'sala-agenda-grade-main--diario': visualizacao === 'dia' }" :aria-busy="carregandoGrade">
              <div v-if="carregandoGrade" class="sala-agenda-grade-loading" role="status" aria-live="polite">
                <i class="fas fa-spinner fa-spin sala-agenda-grade-loading-ico" aria-hidden="true"></i>
                <!-- <span class="sala-agenda-grade-loading-txt">Atualizando eventos…</span> -->
              </div>
              <div class="sala-agenda-legenda-horas sala-agenda-legenda-horas--porta" aria-hidden="true">
                <div class="sala-agenda-legenda-spacer sala-agenda-legenda-spacer--porta" />
                <div class="sala-agenda-legenda-marks sala-agenda-legenda-marks--porta">
                  <span v-for="m in marcasHoras" :key="m.label" class="sala-agenda-marca-hora" :class="{
                    'sala-agenda-marca-hora--inicio': m.isPrimeira,
                    'sala-agenda-marca-hora--fim': m.isUltima,
                  }" :style="{ top: m.topPct + '%' }">{{ m.label }}</span>
                  <!-- <div v-if="indicadorAgoraAtivo" class="sala-agenda-agora-marcador-leg"
                    :style="{ top: linhaAgoraTopPct + '%' }" aria-hidden="true" /> -->
                </div>
              </div>
              <div class="sala-agenda-dias-outer"
                :class="{ 'sala-agenda-dias-outer--semana': visualizacao === 'semana' }">
                <div v-if="visualizacao === 'semana'" class="sala-agenda-nav-semana-col">
                  <button type="button" class="sala-agenda-nav-semana-btn" aria-label="Semana anterior"
                    :disabled="carregandoGrade" @click="semanaAnterior">
                    <i class="fas fa-chevron-left" aria-hidden="true"></i>
                  </button>
                  <div class="sala-agenda-nav-semana-fill" aria-hidden="true" />
                </div>
                <div class="sala-agenda-dias sala-agenda-dias--porta"
                  :class="{ 'sala-agenda-dias--diario': visualizacao === 'dia' }">
                  <div v-for="col in colunasDiasVisiveis" :key="col.key" class="sala-agenda-dia sala-agenda-dia--porta">
                    <div class="sala-agenda-dia-cab sala-agenda-dia-cab--porta"
                    >
                    <!-- :class="{ 'sala-agenda-dia-cab--hoje': col.key === chaveDiaHoje }" -->
                      <span class="sala-agenda-dia-nome">{{ col.rotulo }}</span>
                      <span class="sala-agenda-dia-data">{{ col.dataCurta }}</span>
                    </div>
                    <div class="sala-agenda-dia-track sala-agenda-dia-track--porta">
                      <div v-for="(bl, idx) in blocosPorDia[col.key]" :key="idx"
                        class="sala-agenda-bloco sala-agenda-bloco--porta"
                        :class="{
                          'sala-agenda-bloco--sala-recusou': bl.recursoDeclinou,
                          'sala-agenda-bloco--compacto': bl.heightPct < 8,
                          'sala-agenda-bloco--micro': bl.heightPct < 4,
                        }"
                        :style="{
                          top: bl.topPct + '%',
                          height: bl.heightPct + '%',
                          left: 'calc(3px + (100% - 6px) * ' + (bl.leftPct / 100) + ')',
                          width: 'calc((100% - 6px) * ' + (bl.widthPct / 100) + ')',
                          right: 'auto'
                        }"
                        role="button"
                        tabindex="0"
                        :title="bl.recursoDeclinou ? 'Reserva recusada por conflito de horário — clique para detalhes' : 'Clique para ver detalhes'"
                        :aria-label="ariaLabelBloco(bl)"
                        @click.stop="abrirModalEvento(bl)"
                        @keydown.enter.prevent.stop="abrirModalEvento(bl)"
                        @keydown.space.prevent.stop="abrirModalEvento(bl)">
                        <!-- <span v-if="bl.recursoDeclinou" class="sala-agenda-bloco-conflito-badge" aria-hidden="true">
                          <i class="fas fa-exclamation-triangle" aria-hidden="true"></i> Reserva inválida 
                        </span> -->
                        <span v-if="bl.horario" class="sala-agenda-bloco-hora">{{ bl.horario }}</span>
                        <!-- <span class="sala-agenda-bloco-tit">{{ bl.summary }}</span> -->
                        <span v-if="bl.organizador" class="sala-agenda-bloco-org">Reserva de: </span>
                        <span class="sala-agenda-bloco-tit">{{ bl.organizador }}</span>
                      </div>
                      <div v-if="indicadorAgoraAtivo && col.key === chaveDiaHoje" class="sala-agenda-agora-linha"
                        :style="{ top: linhaAgoraTopPct + '%' }" aria-hidden="true" />
                    </div>
                  </div>
                </div>
                <div v-if="visualizacao === 'semana'" class="sala-agenda-nav-semana-col">
                  <button type="button" class="sala-agenda-nav-semana-btn" aria-label="Próxima semana"
                    :disabled="carregandoGrade" @click="semanaSeguinte">
                    <i class="fas fa-chevron-right" aria-hidden="true"></i>
                  </button>
                  <div class="sala-agenda-nav-semana-fill" aria-hidden="true" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <Teleport to="body">
      <div
        v-if="agendaQueryOk && modalEventoAberto && modalEventoDetalhes"
        class="sala-agenda-modal-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sala-agenda-modal-titulo"
        @click.self="fecharModalEvento"
      >
        <div class="sala-agenda-modal-sheet" @click.stop>
          <!-- <div class="sala-agenda-modal-cab">
            <h2 id="sala-agenda-modal-titulo" class="sala-agenda-modal-titulo">
              {{ modalEventoDetalhes.summary }}
            </h2>
            <button
              type="button"
              class="sala-agenda-modal-btn-fechar"
              aria-label="Fechar"
              @click="fecharModalEvento"
            >
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </div> -->
          <div class="sala-agenda-modal-corpo">
            <p v-if="modalEventoDetalhes.recursoDeclinou" class="sala-agenda-modal-alerta" role="alert">
              <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
              A sala recusou este convite — a reserva pode não valer.
            </p>
            <dl class="sala-agenda-modal-dl">
              <template v-if="modalEventoDetalhes.inicio && modalEventoDetalhes.fim">
                <dt>Quando</dt>
                <dd>{{ formatarIntervaloModal(modalEventoDetalhes.inicio, modalEventoDetalhes.fim) }}</dd>
              </template>
              <template v-if="modalEventoDetalhes.organizador">
                <dt>Organizador</dt>
                <dd>{{ modalEventoDetalhes.organizador }}</dd>
              </template>
              <!-- <template v-if="modalEventoDetalhes.location">
                <dt>Local</dt>
                <dd>{{ modalEventoDetalhes.location }}</dd>
              </template> -->
              <!-- <template v-if="modalEventoDetalhes.description && modalEventoDetalhes.description.trim()">
                <dt>Descrição</dt>
                <dd class="sala-agenda-modal-desc">{{ modalEventoDetalhes.description }}</dd>
              </template> -->
              <template v-if="participantesModalLista.length">
                <dt>Participantes</dt>
                <dd>
                  <ol class="sala-agenda-modal-participantes">
                    <li v-for="(p, i) in participantesModalLista" :key="'p-' + i">
                      <div class="sala-agenda-modal-part-linha">
                        <span class="sala-agenda-modal-part-nome">{{ p.nome }}</span>
                        <span class="chip" :class="p.chipClass">{{ p.statusLabel }}</span>
                      </div>
                    </li>
                  </ol>
                </dd>
              </template>
              <template v-if="modalEventoDetalhes.status && modalEventoDetalhes.status !== 'confirmed'">
                <dt>Status</dt>
                <dd>{{ modalEventoDetalhes.status }}</dd>
              </template>
            </dl>
            <!-- <div v-if="modalEventoDetalhes.htmlLink || modalEventoDetalhes.hangoutLink" class="sala-agenda-modal-acoes">
              <a
                v-if="modalEventoDetalhes.htmlLink"
                :href="modalEventoDetalhes.htmlLink"
                class="sala-agenda-modal-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir no Google Agenda
              </a>
              <a
                v-if="modalEventoDetalhes.hangoutLink"
                :href="modalEventoDetalhes.hangoutLink"
                class="sala-agenda-modal-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                Link da videoconferência
              </a>
            </div> -->
          </div>
          <!-- <p class="sala-agenda-modal-rodape" aria-hidden="true">Fecha automaticamente em 1 minuto ou ao fechar.</p> -->
        </div>
      </div>
    </Teleport>
  </section>
</template>

<script>
import { eventosPortaPorToken } from "@/services/sala-reuniao-service";
import {
  intervaloSemanaUtilIso,
  datasSemanaUtil,
  rotulosCincoDias,
  eventosPorDiaGrade,
  marcasHorasParaGrade,
  minutosDesdeMeiaNoite,
  estadoOcupacaoSala,
  DISPLAY_START_MIN,
  DISPLAY_END_MIN,
} from "@/utils/sala-agenda-helpers";
import { salvarAgendaInstalacaoPwa } from "@/utils/pwa-agenda-inicio";
import logoAgendaHeader from "@/assets/img/thalamus.svg";
const POLL_MS = 120_000;
const RELOGIO_MS = 30_000;
/**
 * Após alternar para a semana, volta sozinho para o dia atual (visão diária).
 * Após mudar o dia no seletor, volta ao dia de hoje (mesma duração).
 */
const VOLTAR_VISAO_DIA_MS = 60_000;
/** Fechamento automático do modal de detalhes do evento */
const MODAL_EVENTO_AUTO_FECHAR_MS = 60_000;

function queryStr(q) {
  if (q == null) return "";
  return String(q).trim();
}

/** Mesma regra que em sala-agenda-helpers — oculta calendários de recurso na lista de participantes. */
function emailEhCalendarioRecursoAgenda(email) {
  if (email == null || email === "") return true;
  const s = String(email).trim().toLowerCase();
  return s.includes("@resource.calendar.google.com") || /^c_[a-z0-9]+@/i.test(s);
}

/** Elemento em fullscreen (prefixos legados). */
function obterElementoFullscreenDoc() {
  if (typeof document === "undefined") return null;
  return (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement ||
    null
  );
}

/** Indica se a API de fullscreen está disponível no `documentElement`. */
function fullscreenApiDisponivel() {
  if (typeof document === "undefined") return false;
  const el = document.documentElement;
  return !!(el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen);
}

export default {
  name: "AgendaSalaView",

  data() {
    return {
      logoAgendaHeader,
      salaNomeExibicao: "",
      tituloDocumentoAnterior: "",
      eventos: [],
      carregando: false,
      /** Recarga silenciosa (troca de semana / intervalo) — overlay na grade. */
      carregandoGrade: false,
      dadosCarregados: false,
      erro: "",
      erroGoogle: false,
      erroToken: false,
      pollTimer: null,
      relogioTimer: null,
      /** Atualizado em intervalo — linha "agora" e relógio no header */
      agora: new Date(),
      /** Sincronizado com eventos `fullscreenchange` */
      emFullscreen: false,
      /** iOS / Safari: sem API Fullscreen no documento — ocupa viewport com CSS */
      imersivoCss: false,
      /** Padrão: semana inteira. Ao tocar em “Semana”, volta a `dia` após {@link VOLTAR_VISAO_DIA_MS}. */
      visualizacao: "semana",
      timerVoltaDia: null,
      /** Semanas em relação à semana corrente (0 = esta semana). */
      semanaDeslocamento: 0,
      /** Índice 0–4 (seg–sex) na visão diária. */
      indiceDiaUtil: 0,
      modalEventoAberto: false,
      modalEventoDetalhes: null,
      modalEventoTimerId: null,
    };
  },

  computed: {
    /** Token do display na porta (query `token`). */
    displayToken() {
      return queryStr(this.$route.query.token);
    },
    /** Nome amigável opcional (query `nome`) — sobrescreve só se o backend não enviar. */
    nomeQuery() {
      return queryStr(this.$route.query.nome);
    },
    /** `token` presente na URL. */
    agendaQueryOk() {
      return this.displayToken.length > 0;
    },
    tituloSala() {
      if (this.salaNomeExibicao) return this.salaNomeExibicao;
      if (this.nomeQuery) return this.nomeQuery;
      return "Sala de reunião";
    },
    monday() {
      return datasSemanaUtil(this.semanaDeslocamento).monday;
    },
    colunasDias() {
      return rotulosCincoDias(this.monday);
    },
    /** Coluna única na visão diária conforme {@link indiceDiaUtil}. */
    colunasDiasVisiveis() {
      if (this.visualizacao === "semana") {
        return this.colunasDias;
      }
      const cols = this.colunasDias;
      if (!cols.length) return [];
      const idx = Math.min(Math.max(0, this.indiceDiaUtil), cols.length - 1);
      const col = cols[idx];
      return col ? [col] : [cols[0]];
    },
    blocosPorDia() {
      return eventosPorDiaGrade(this.eventos, this.monday);
    },
    marcasHoras() {
      return marcasHorasParaGrade();
    },
    exemploUrl() {
      return "/#/agenda-sala?token=SEU_TOKEN_DO_DISPLAY";
    },
    /** Chave yyyy-mm-dd do dia corrente (hora local). */
    chaveDiaHoje() {
      const d = this.agora;
      const mes = String(d.getMonth() + 1).padStart(2, "0");
      const dia = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${mes}-${dia}`;
    },
    /** Hoje é dia útil (seg–sex) e está na grade desta semana. */
    indicadorAgoraAtivo() {
      const dow = this.agora.getDay();
      if (dow < 1 || dow > 5) return false;
      return this.colunasDias.some((c) => c.key === this.chaveDiaHoje);
    },
    /** Posição vertical da linha "agora" na faixa 8:00–18:00 (%). */
    linhaAgoraTopPct() {
      const min = minutosDesdeMeiaNoite(this.agora);
      const span = DISPLAY_END_MIN - DISPLAY_START_MIN;
      if (min <= DISPLAY_START_MIN) return 0;
      if (min >= DISPLAY_END_MIN) return 100;
      return ((min - DISPLAY_START_MIN) / span) * 100;
    },
    relogioDataCabecalho() {
      return this.agora.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    relogioHoraCabecalho() {
      return this.agora.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    },
    relogioTituloTooltip() {
      return `${this.relogioDataCabecalho} · ${this.relogioHoraCabecalho}`;
    },
    agoraDatetimeISO() {
      return this.agora.toISOString();
    },
    /** Botão some em fullscreen nativo ou em modo imersivo CSS (mobile). */
    mostrarBotaoTelaCheia() {
      if (fullscreenApiDisponivel()) {
        return !this.emFullscreen;
      }
      return !this.imersivoCss;
    },
    /** Participantes do modal: nome + chip de status (classes globais .chip, .bg-* do thalamus). */
    participantesModalLista() {
      const d = this.modalEventoDetalhes;
      if (!d || !Array.isArray(d.attendees)) return [];
      /** @type {Record<string, { chipClass: string, statusLabel: string }>} */
      const mapa = {
        accepted: { chipClass: "bg-sucesso", statusLabel: "Aceito" },
        declined: { chipClass: "bg-erro", statusLabel: "Recusado" },
        tentative: { chipClass: "bg-alerta", statusLabel: "Talvez" },
        needsaction: { chipClass: "bg-cinza", statusLabel: "Pendente" },
      };
      const out = [];
      for (let i = 0; i < d.attendees.length; i++) {
        const a = d.attendees[i];
        if (a == null || typeof a !== "object") continue;
        const em = a.email != null ? String(a.email).trim() : "";
        if (emailEhCalendarioRecursoAgenda(em)) continue;
        const dn = a.displayName != null ? String(a.displayName).trim() : "";
        const nome = dn || em;
        if (!nome) continue;
        const rs = a.responseStatus != null ? String(a.responseStatus).toLowerCase() : "";
        const cfg = mapa[rs] || { chipClass: "bg-cinza", statusLabel: "Sem resposta" };
        out.push({ nome, chipClass: cfg.chipClass, statusLabel: cfg.statusLabel });
      }
      return out;
    },
    /**
     * Indicador ao vivo só no “agora”: some se a semana não for a atual,
     * ou na visão dia se a coluna visível não for o dia de hoje.
     */
    salaStatusUi() {
      if (!this.dadosCarregados || this.erro) {
        return null;
      }
      if (this.erroGoogle || this.erroToken) {
        return null;
      }
      if (this.semanaDeslocamento !== 0) {
        return null;
      }
      if (this.visualizacao === "dia") {
        const vis = this.colunasDiasVisiveis[0];
        if (!vis || vis.key !== this.chaveDiaHoje) {
          return null;
        }
      }
      const temHojeNaGrade = this.colunasDias.some((c) => c.key === this.chaveDiaHoje);
      if (!temHojeNaGrade) {
        return null;
      }
      const base = estadoOcupacaoSala(this.eventos, this.agora, { emBreveMinutos: 25 });
      const icones = {
        livre: "fa-door-open",
        em_breve: "fa-clock",
        ocupada: "fa-users",
      };
      return {
        ...base,
        icone: icones[base.codigo] || "fa-info-circle",
      };
    },
  },

  watch: {
    "$route.query": {
      deep: true,
      handler() {
        if (this.agendaQueryOk) {
          salvarAgendaInstalacaoPwa(this.$route.query);
        }
        this.semanaDeslocamento = 0;
        this.inicializarIndiceDiaPorHoje();
        this.reiniciarPolling();
        this.reload();
        if (this.agendaQueryOk) {
          this.iniciarRelogio();
        } else {
          this.pararRelogio();
          this.pararTimerVoltaVisaoDiaria();
          this.visualizacao = "semana";
        }
      },
    },
    tituloSala() {
      this.atualizarTituloDocumento();
    },
  },

  mounted() {
    this.tituloDocumentoAnterior = typeof document !== "undefined" ? document.title : "";
    document.documentElement.classList.add("sala-porta-html");
    if (this.agendaQueryOk) {
      salvarAgendaInstalacaoPwa(this.$route.query);
    }
    this.inicializarIndiceDiaPorHoje();
    this.reiniciarPolling();
    this.reload();
    this.atualizarTituloDocumento();
    if (this.agendaQueryOk) {
      this.iniciarRelogio();
    }
    if (typeof document !== "undefined") {
      document.addEventListener("fullscreenchange", this.sincronizarFullscreen);
      document.addEventListener("webkitfullscreenchange", this.sincronizarFullscreen);
      document.addEventListener("mozfullscreenchange", this.sincronizarFullscreen);
      document.addEventListener("MSFullscreenChange", this.sincronizarFullscreen);
      this.sincronizarFullscreen();
      document.addEventListener("keydown", this.onKeydownSairImersivo);
    }
  },

  beforeUnmount() {
    this.fecharModalEvento();
    this.pararTimerVoltaVisaoDiaria();
    this.pararRelogio();
    this.pararPolling();
    if (typeof document !== "undefined") {
      document.removeEventListener("fullscreenchange", this.sincronizarFullscreen);
      document.removeEventListener("webkitfullscreenchange", this.sincronizarFullscreen);
      document.removeEventListener("mozfullscreenchange", this.sincronizarFullscreen);
      document.removeEventListener("MSFullscreenChange", this.sincronizarFullscreen);
      document.removeEventListener("keydown", this.onKeydownSairImersivo);
    }
    this.sairImersivoCss();
    document.documentElement.classList.remove("sala-porta-html");
    if (typeof document !== "undefined") {
      document.title = this.tituloDocumentoAnterior || "";
    }
  },

  methods: {
    /** Tooltip acessível só quando a sala (recurso) respondeu declined — o outro evento sobreposto fica visual normal. */
    ariaSalaRecusou(bl) {
      if (!bl || !bl.recursoDeclinou) return undefined;
      let s = "A sala recusou o convite — a reserva pode não valer.";
      if (bl.horario) s += ". " + bl.horario;
      if (bl.organizador) s += ". " + bl.organizador;
      return s;
    },
    ariaLabelBloco(bl) {
      if (!bl) return "Evento. Ver detalhes.";
      if (bl.recursoDeclinou) {
        let s = "A sala recusou o convite — a reserva pode não valer.";
        if (bl.horario) s += " " + bl.horario;
        if (bl.organizador) s += " " + bl.organizador;
        return s + " Ver detalhes.";
      }
      const parts = [];
      if (bl.horario) parts.push(bl.horario);
      if (bl.organizador) parts.push(bl.organizador);
      else if (bl.summary) parts.push(bl.summary);
      return (parts.length ? parts.join(". ") : "Evento") + ". Ver detalhes.";
    },
    abrirModalEvento(bl) {
      if (!bl || !bl.detalhes) return;
      if (this.modalEventoTimerId != null) {
        clearTimeout(this.modalEventoTimerId);
        this.modalEventoTimerId = null;
      }
      this.modalEventoDetalhes = bl.detalhes;
      this.modalEventoAberto = true;
      if (typeof document !== "undefined") {
        document.body.style.overflow = "hidden";
      }
      this.modalEventoTimerId = setTimeout(() => {
        this.modalEventoTimerId = null;
        this.fecharModalEvento();
      }, MODAL_EVENTO_AUTO_FECHAR_MS);
    },
    fecharModalEvento() {
      if (this.modalEventoTimerId != null) {
        clearTimeout(this.modalEventoTimerId);
        this.modalEventoTimerId = null;
      }
      this.modalEventoAberto = false;
      this.modalEventoDetalhes = null;
      if (typeof document !== "undefined") {
        if (!this.imersivoCss) {
          document.body.style.overflow = "";
        }
      }
    },
    formatarIntervaloModal(inicioIso, fimIso) {
      const a = new Date(inicioIso);
      const b = new Date(fimIso);
      if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return "";
      const opcoesData = { weekday: "long", day: "2-digit", month: "long", year: "numeric" };
      const opcoesHora = { hour: "2-digit", minute: "2-digit", hour12: false };
      if (a.toDateString() === b.toDateString()) {
        return `${a.toLocaleDateString("pt-BR", opcoesData)} · ${a.toLocaleTimeString("pt-BR", opcoesHora)} – ${b.toLocaleTimeString(
          "pt-BR",
          opcoesHora,
        )}`;
      }
      return `${a.toLocaleString("pt-BR", { ...opcoesData, ...opcoesHora })} → ${b.toLocaleString("pt-BR", {
        ...opcoesData,
        ...opcoesHora,
      })}`;
    },
    inicializarIndiceDiaPorHoje() {
      const now = new Date();
      const dow = now.getDay();
      if (dow >= 1 && dow <= 5) {
        this.indiceDiaUtil = dow - 1;
      } else {
        this.indiceDiaUtil = 0;
      }
    },

    semanaAnterior() {
      this.semanaDeslocamento -= 1;
      if (this.agendaQueryOk) {
        this.reload({ silencioso: true, mostrarCarregandoGrade: true });
      }
    },

    semanaSeguinte() {
      this.semanaDeslocamento += 1;
      if (this.agendaQueryOk) {
        this.reload({ silencioso: true, mostrarCarregandoGrade: true });
      }
    },

    pararTimerVoltaVisaoDiaria() {
      if (this.timerVoltaDia != null) {
        clearTimeout(this.timerVoltaDia);
        this.timerVoltaDia = null;
      }
    },

    iniciarTimerVoltaVisaoDiaria() {
      this.pararTimerVoltaVisaoDiaria();
      this.timerVoltaDia = setTimeout(() => {
        this.timerVoltaDia = null;
        this.visualizacao = "dia";
      }, VOLTAR_VISAO_DIA_MS);
    },

    definirVisualizacao(mod) {
      if (mod !== "dia" && mod !== "semana") {
        return;
      }
      this.visualizacao = mod;
      if (mod === "semana") {
        this.iniciarTimerVoltaVisaoDiaria();
      } else {
        this.pararTimerVoltaVisaoDiaria();
      }
    },

    sincronizarFullscreen() {
      this.emFullscreen = !!obterElementoFullscreenDoc();
    },

    onKeydownSairImersivo(e) {
      if (e.key === "Escape" && this.modalEventoAberto) {
        this.fecharModalEvento();
        return;
      }
      if (e.key !== "Escape" || !this.imersivoCss) return;
      this.sairImersivoCss();
    },

    sairImersivoCss() {
      if (!this.imersivoCss) return;
      this.imersivoCss = false;
      if (typeof document !== "undefined") {
        document.body.style.overflow = "";
      }
    },

    entrarImersivoCss() {
      this.imersivoCss = true;
      if (typeof document !== "undefined") {
        document.body.style.overflow = "hidden";
      }
    },

    /** Desktop/Android: Fullscreen API; iOS e afins: viewport fixo (sem barra do browser não é possível só com JS). */
    async entrarTelaCheia() {
      if (typeof document === "undefined") return;
      if (fullscreenApiDisponivel()) {
        try {
          const el = document.documentElement;
          const req =
            el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
          if (req) await req.call(el);
        } catch (_) {
          /* fallback */
        }
        this.sincronizarFullscreen();
        return;
      }
      this.entrarImersivoCss();
    },

    atualizarTituloDocumento() {
      if (typeof document === "undefined") return;
      if (this.agendaQueryOk) {
        document.title = `${this.tituloSala} · Agenda`;
      }
    },

    iniciarRelogio() {
      if (this.relogioTimer != null) return;
      this.agora = new Date();
      this.relogioTimer = setInterval(() => {
        this.agora = new Date();
      }, RELOGIO_MS);
    },

    pararRelogio() {
      if (this.relogioTimer != null) {
        clearInterval(this.relogioTimer);
        this.relogioTimer = null;
      }
    },

    pararPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },

    reiniciarPolling() {
      this.pararPolling();
      if (!this.agendaQueryOk) return;
      this.pollTimer = setInterval(() => {
        this.reload({ silencioso: true });
      }, POLL_MS);
    },

    async reload(opts = {}) {
      const silencioso = Boolean(opts.silencioso);
      const mostrarCarregandoGrade = Boolean(opts.mostrarCarregandoGrade);
      if (!this.agendaQueryOk) {
        this.eventos = [];
        this.dadosCarregados = false;
        this.erro = "";
        this.erroGoogle = false;
        this.erroToken = false;
        this.carregando = false;
        this.carregandoGrade = false;
        return;
      }

      if (!silencioso) {
        this.carregando = true;
      } else if (mostrarCarregandoGrade) {
        this.carregandoGrade = true;
      }
      this.erro = "";
      this.erroGoogle = false;
      this.erroToken = false;

      const { inicio, fim } = intervaloSemanaUtilIso(this.semanaDeslocamento);

      try {
        const data = await eventosPortaPorToken(this.displayToken, inicio, fim);
        this.salaNomeExibicao = data.sala?.nome || this.nomeQuery || "Sala de reunião";
        this.eventos = data.events || [];
        this.dadosCarregados = true;
      } catch (e) {
        const code = e?.response?.data?.code;
        const status = e?.response?.status;
        if (status === 401 || code === "display_token_invalid") {
          this.erroToken = true;
          this.erro = e?.response?.data?.message || "Token de display inválido ou inativo.";
          this.eventos = [];
          this.dadosCarregados = true;
        } else if (status === 403 && code === "google_not_connected") {
          this.erroGoogle = true;
          this.eventos = [];
          this.dadosCarregados = true;
        } else {
          this.erro = e?.response?.data?.message || e?.message || "Erro ao carregar agenda.";
        }
      } finally {
        if (!silencioso) {
          this.carregando = false;
        }
        if (mostrarCarregandoGrade) {
          this.carregandoGrade = false;
        }
      }
    },
  },
};
</script>

<style scoped>
/* Fundo com cor (primária Thalamus) + cartão vidro; sem faixa de header */
.sala-agenda-view--porta {
  --sala-agenda-cabeca-altura: clamp(1.9rem, 3.4vw, 2.45rem);
  --sala-agenda-slot-gap: 6px;
  --sala-agenda-linha: color-mix(in srgb, var(--cor-primaria) 32%, var(--cor-separador));
  --sala-agenda-coluna: color-mix(in srgb, var(--cor-bg) 52%, var(--cor-primaria-fraca) 48%);
  position: relative;
  overflow: hidden;
  isolation: isolate;
  min-height: 100vh;
  min-height: 100dvh;
  color: var(--cor-fonte);
  background-color: color-mix(in srgb, var(--cor-primaria) 6%, var(--cor-bg));
  background-image: radial-gradient(ellipse 95% 70% at 0% 0%,
      color-mix(in srgb, var(--cor-primaria) 24%, transparent) 0%,
      transparent 55%),
    radial-gradient(ellipse 60% 45% at 100% 8%, color-mix(in srgb, var(--cor-primaria-media) 100%, transparent) 0%, transparent 52%),
    linear-gradient(168deg,
      var(--cor-bg) 0%,
      color-mix(in srgb, var(--cor-primaria-fraca) 50%, var(--cor-bg)) 42%,
      color-mix(in srgb, var(--cor-primaria) 9%, #f3f6fc) 100%),
    url("~@/assets/img/grafismo2.svg");
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: 0 0, 100% 0, 0 0, center bottom;
  background-size: 100% 100%, 100% 100%, 100% 100%, cover;
}

.sala-agenda-view--porta:has(.sala-agenda-surface) {
  height: 100dvh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

/* Sem Fullscreen API (ex.: iOS Safari): fixa no viewport; barra do browser não some só com isso */
.sala-agenda-view--porta.sala-agenda-view--imersivo {
  position: fixed;
  inset: 0;
  z-index: 2147482000;
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: none;
  min-height: 0;
  padding: env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px);
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sala-agenda-view--porta.sala-agenda-view--imersivo .sala-porta-body:has(.sala-agenda-surface) {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.sala-agenda-btn-sair-imersivo {
  position: fixed;
  bottom: max(12px, env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 2147482100;
  margin: 0;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 28%, var(--cor-separador));
  background: color-mix(in srgb, var(--cor-bg) 88%, var(--cor-primaria-fraca));
  color: var(--cor-primaria-forte);
  font-size: clamp(0.75rem, 2.8vw, 0.9rem);
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 12px color-mix(in srgb, var(--cor-fonte-forte) 12%, transparent);
}

.sala-porta-body {
  position: relative;
  z-index: 1;
  max-width: 1420px;
  margin: 0 auto;
  width: 100%;
  padding: clamp(6px, 1.2vw, 10px) clamp(8px, 1.8vw, 14px) clamp(6px, 1.2vw, 8px);
  box-sizing: border-box;
  background: transparent;
}

.sala-porta-body:has(.sala-agenda-surface) {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* Cartão: vidro + acento industrial (tablet fixo em porta) */
.sala-agenda-surface {
  position: relative;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  padding: 10px 12px 12px;
  overflow: hidden;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 28%, rgba(255, 255, 255, 0.65));
  border-left: 4px solid color-mix(in srgb, var(--cor-primaria) 72%, var(--cor-fonte-forte));
  background: linear-gradient(145deg,
      color-mix(in srgb, var(--cor-primaria-fraca) 62%, rgba(255, 255, 255, 0.5)) 0%,
      rgba(255, 255, 255, 0.22) 48%,
      color-mix(in srgb, var(--cor-primaria-fraca) 35%, rgba(245, 247, 250, 0.9)) 100%);
  backdrop-filter: blur(14px) saturate(1.35);
  -webkit-backdrop-filter: blur(14px) saturate(1.35);
  box-shadow:
    0 16px 48px color-mix(in srgb, var(--cor-fonte-forte) 10%, transparent),
    0 2px 0 rgba(255, 255, 255, 0.55) inset;
}

/* Marca d’água Thalamus atrás da grade */
.sala-agenda-surface::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: url("~@/assets/img/thalamus.svg") center 46% / min(82vmin, 520px) auto no-repeat;
  opacity: 0.18;
}

/* Faixa de título acima de SEG–SEX — flex com colunas iguais para o título ficar centralizado com relógio à direita */
.sala-agenda-semana-header {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 10px 6px 12px;
  margin: 0 0 4px;
  gap: 8px;
  box-sizing: border-box;
  background: transparent;
  box-shadow: none;
  border-bottom: 1px solid color-mix(in srgb, var(--cor-primaria) 18%, var(--cor-separador));
}

/* Estado da sala — leitura rápida à distância (cores semânticas) */
.sala-agenda-status-porta {
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: clamp(10px, 2vw, 16px);
  margin: 2px 2px 12px;
  padding: clamp(12px, 2.2vw, 16px) clamp(14px, 2.5vw, 20px);
  border-radius: 16px;
  border: 1px solid color-mix(in srgb, var(--cor-fonte-forte) 12%, transparent);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.4),
    0 4px 16px color-mix(in srgb, var(--cor-fonte-forte) 7%, transparent);
}

.sala-agenda-status-ico {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(2.5rem, 6vw, 3.35rem);
  height: clamp(2.5rem, 6vw, 3.35rem);
  border-radius: 12px;
  font-size: clamp(1.1rem, 3vw, 1.5rem);
}

.sala-agenda-status-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.sala-agenda-status-titulo {
  font-size: clamp(1.02rem, 2.7vw, 1.28rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.12;
  color: var(--cor-fonte-forte);
}

.sala-agenda-status-detalhe {
  font-size: clamp(0.74rem, 1.7vw, 0.9rem);
  font-weight: 600;
  line-height: 1.3;
  color: color-mix(in srgb, var(--cor-fonte-forte) 88%, var(--cor-fonte));
}

.sala-agenda-status-porta--livre {
  background: linear-gradient(135deg,
      color-mix(in srgb, var(--cor-sucesso) 20%, var(--cor-bg)) 0%,
      color-mix(in srgb, var(--cor-sucesso) 10%, var(--cor-bg)) 100%);
  border-color: color-mix(in srgb, var(--cor-sucesso) 38%, var(--cor-separador));
}

.sala-agenda-status-porta--livre .sala-agenda-status-ico {
  background: color-mix(in srgb, var(--cor-sucesso) 22%, transparent);
  color: var(--cor-sucesso);
}

.sala-agenda-status-porta--em_breve {
  background: linear-gradient(135deg,
      color-mix(in srgb, var(--cor-alerta) 18%, var(--cor-bg)) 0%,
      color-mix(in srgb, var(--cor-alerta) 10%, var(--cor-bg)) 100%);
  border-color: color-mix(in srgb, var(--cor-alerta) 35%, var(--cor-separador));
}

/* --cor-alerta é muito clara (#fdfd25): ícone precisa de tom mais escuro para contraste no fundo amarelado */
.sala-agenda-status-porta--em_breve .sala-agenda-status-ico {
  background: color-mix(in srgb, var(--cor-alerta) 38%, var(--cor-fonte-forte) 6%);
  color: color-mix(in srgb, var(--cor-alerta) 18%, var(--cor-fonte-forte) 82%);
}

.sala-agenda-status-porta--ocupada {
  background: linear-gradient(135deg,
      color-mix(in srgb, var(--cor-erro) 16%, var(--cor-bg)) 0%,
      color-mix(in srgb, var(--cor-erro) 9%, var(--cor-bg)) 100%);
  border-color: color-mix(in srgb, var(--cor-erro) 36%, var(--cor-separador));
}

.sala-agenda-status-porta--ocupada .sala-agenda-status-ico {
  background: color-mix(in srgb, var(--cor-erro) 20%, transparent);
  color: var(--cor-erro);
}

.sala-agenda-status-porta--indisponivel {
  background: linear-gradient(135deg,
      color-mix(in srgb, var(--cor-erro) 12%, var(--cor-bg)) 0%,
      color-mix(in srgb, var(--cor-erro) 6%, var(--cor-bg)) 100%);
  border-color: color-mix(in srgb, var(--cor-erro) 28%, var(--cor-separador));
}

.sala-agenda-status-porta--indisponivel .sala-agenda-status-ico {
  background: color-mix(in srgb, var(--cor-erro) 16%, transparent);
  color: var(--cor-erro);
}

.sala-agenda-visao-btns {
  display: inline-flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
  flex-shrink: 0;
}

.sala-agenda-visao-btns--compacto {
  padding: 2px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cor-fonte-forte) 5%, transparent);
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 18%, var(--cor-separador));
}

.sala-agenda-visao-btn {
  min-width: 0;
  padding: 4px 12px;
  margin: 0;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: color-mix(in srgb, var(--cor-fonte-forte) 78%, var(--cor-fonte-fraca));
  font-size: clamp(0.6rem, 1.35vw, 0.72rem);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  line-height: 1.2;
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
}

.sala-agenda-visao-btns--compacto .sala-agenda-visao-btn:hover {
  color: var(--cor-fonte-forte);
}

.sala-agenda-visao-btn:focus-visible {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
}

.sala-agenda-visao-btn--ativo {
  background: color-mix(in srgb, var(--cor-bg) 92%, var(--cor-primaria-fraca));
  color: var(--cor-primaria-forte);
  box-shadow: 0 1px 3px color-mix(in srgb, var(--cor-fonte-forte) 10%, transparent);
}

.sala-agenda-header-lead {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sala-agenda-header-logo {
  display: block;
  height: clamp(28px, 4.2vmin, 40px);
  width: auto;
  max-width: min(28vw, 120px);
  flex-shrink: 0;
  object-fit: contain;
  object-position: left center;
}

.sala-agenda-header-lead-fill {
  flex: 1 1 0;
  min-width: 0;
}

.sala-agenda-header-aside {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 8px 10px;
}

.sala-agenda-header-aside .sala-agenda-visao-btns--compacto {
  flex-shrink: 0;
}

.sala-agenda-header-aside-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  max-width: 100%;
}

.sala-agenda-btn-fullscreen {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: clamp(2.25rem, 5vmin, 2.75rem);
  height: clamp(2.25rem, 5vmin, 2.75rem);
  margin: 0;
  padding: 0;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 22%, var(--cor-separador));
  background: color-mix(in srgb, var(--cor-bg) 50%, rgba(255, 255, 255, 0.35));
  color: var(--cor-primaria-forte);
  cursor: pointer;
  box-shadow: 0 1px 6px color-mix(in srgb, var(--cor-primaria-forte) 10%, transparent);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.sala-agenda-btn-fullscreen:hover {
  background: color-mix(in srgb, var(--cor-primaria-fraca) 65%, var(--cor-bg));
  border-color: color-mix(in srgb, var(--cor-primaria) 35%, var(--cor-separador));
}

.sala-agenda-btn-fullscreen:active {
  transform: scale(0.97);
}

.sala-agenda-btn-fullscreen:focus-visible {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
}

.sala-agenda-btn-fullscreen .fas {
  font-size: clamp(0.85rem, 1.8vw, 1rem);
}

.sala-agenda-relogio {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 2px;
  max-width: min(40vw, 9.5rem);
  line-height: 1.2;
  text-align: right;
  font-variant-numeric: tabular-nums lining-nums;
}

.sala-agenda-relogio-data {
  font-size: clamp(0.62rem, 1.2vw, 0.74rem);
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--cor-fonte-fraca);
  opacity: 0.95;
}

.sala-agenda-relogio-hora {
  font-size: clamp(0.88rem, 2.1vw, 1.08rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--cor-primaria-forte);
}

.sala-agenda-sala-eyebrow {
  display: block;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--cor-fonte-fraca);
  line-height: 1.2;
  margin-bottom: 4px;
}

.sala-agenda-sala-titulo {
  margin: 0;
  padding: 0;
  font-size: clamp(1.05rem, 2.5vw, 1.45rem);
  font-weight: 800;
  letter-spacing: -0.035em;
  line-height: 1.15;
  color: var(--cor-primaria-forte);
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  word-break: break-word;
  hyphens: auto;
}

.sala-agenda-semana-header .sala-agenda-sala-titulo {
  flex: 0 1 auto;
  max-width: min(42vw, 100%);
  text-align: center;
  min-width: 0;
}

.sala-porta-panel {
  border-radius: 12px;
  padding: 24px;
  background: var(--cor-bg);
  box-shadow: 0 1px 3px color-mix(in srgb, var(--cor-fonte-forte) 8%, transparent);
  border: 1px solid var(--cor-separador);
  text-align: center;
}

.sala-porta-panel--alert {
  border-left: 4px solid var(--cor-primaria);
  text-align: left;
}

.sala-porta-panel-title {
  font-weight: 700;
  margin: 0 0 8px;
  font-size: 1.05rem;
}

.sala-porta-pre {
  margin-top: 12px;
  padding: 12px;
  font-size: 11px;
  overflow-x: auto;
  background: var(--cor-cinza2);
  border-radius: 8px;
  border: 1px solid var(--cor-separador);
  word-break: break-all;
}

.sala-porta-panel--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-size: 1rem;
  color: var(--cor-fonte-fraca);
}

.sala-porta-spin {
  font-size: 1.25rem;
}

.sala-porta-btn {
  margin-top: 16px;
  padding: 12px 28px;
  border-radius: 8px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  color: var(--cor-bg);
  background: var(--cor-primaria);
  box-shadow: none;
}

.sala-porta-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sala-agenda-grade-wrap--porta {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 0;
  overflow: hidden;
  padding: 0;
}

.sala-agenda-grade-main--porta {
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
  align-items: stretch;
  gap: clamp(5px, 1vw, 9px);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-gutter: stable;
}

/**
 * Visão diária: legenda + coluna como um bloco (sem a coluna “flutuando” ao centro com horas longe).
 */
.sala-agenda-grade-main--diario {
  justify-content: center;
  gap: clamp(4px, 0.85vw, 8px);
}

.sala-agenda-grade-main--diario .sala-agenda-legenda-horas--porta {
  flex: 0 0 clamp(2rem, 3.1vw, 2.55rem);
}

.sala-agenda-grade-main--diario .sala-agenda-dias-outer {
  flex: 0 1 min(92vw, 640px);
  max-width: min(92vw, 640px);
  min-width: 0;
}

.sala-agenda-grade-loading {
  position: absolute;
  inset: 0;
  z-index: 25;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 0;
  padding: 16px;
  box-sizing: border-box;
  pointer-events: auto;
  cursor: wait;
  background: color-mix(in srgb, var(--cor-bg) 72%, transparent);
  backdrop-filter: blur(6px) saturate(1.1);
  -webkit-backdrop-filter: blur(6px) saturate(1.1);
  border-radius: 12px;
}

.sala-agenda-grade-loading-ico {
  font-size: clamp(1.35rem, 3.5vw, 1.75rem);
  color: var(--cor-primaria-forte);
}

.sala-agenda-grade-loading-txt {
  font-size: clamp(0.78rem, 1.8vw, 0.95rem);
  font-weight: 700;
  color: var(--cor-primaria-forte);
  letter-spacing: 0.03em;
}

.sala-agenda-legenda-horas--porta {
  flex: 0 0 clamp(2.4rem, 3.8vw, 3.1rem);
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-height: 0;
  gap: var(--sala-agenda-slot-gap);
}

.sala-agenda-legenda-spacer--porta {
  height: var(--sala-agenda-cabeca-altura);
  min-height: var(--sala-agenda-cabeca-altura);
  flex-shrink: 0;
  box-sizing: border-box;
}

.sala-agenda-legenda-marks--porta {
  position: relative;
  flex: 1;
  min-height: 0;
  font-size: clamp(0.62rem, 1.2vw, 0.76rem);
  font-weight: 700;
  letter-spacing: 0.02em;
  color: color-mix(in srgb, var(--cor-fonte-forte) 72%, var(--cor-primaria-forte) 28%);
  font-variant-numeric: tabular-nums lining-nums;
}

.sala-agenda-dias-outer {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  min-width: 0;
  min-height: 0;
  gap: clamp(2px, 0.55vw, 6px);
}

.sala-agenda-nav-semana-col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--sala-agenda-slot-gap);
  flex: 0 0 auto;
  width: clamp(1.75rem, 3.6vw, 2.4rem);
  min-width: 0;
}

.sala-agenda-nav-semana-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: var(--sala-agenda-cabeca-altura);
  min-height: var(--sala-agenda-cabeca-altura);
  margin: 0;
  padding: 0;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 22%, var(--cor-separador));
  background: color-mix(in srgb, var(--cor-bg) 50%, rgba(255, 255, 255, 0.35));
  color: var(--cor-primaria-forte);
  cursor: pointer;
  box-shadow: 0 1px 6px color-mix(in srgb, var(--cor-primaria-forte) 8%, transparent);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.1s ease;
}

.sala-agenda-nav-semana-btn:hover {
  background: color-mix(in srgb, var(--cor-primaria-fraca) 50%, var(--cor-bg));
  border-color: color-mix(in srgb, var(--cor-primaria) 35%, var(--cor-separador));
}

.sala-agenda-nav-semana-btn:active {
  transform: scale(0.96);
}

.sala-agenda-nav-semana-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

.sala-agenda-nav-semana-btn:focus-visible {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
}

.sala-agenda-nav-semana-btn .fas {
  font-size: clamp(0.75rem, 1.6vw, 0.95rem);
}

.sala-agenda-nav-semana-fill {
  flex: 1;
  min-height: 0;
  pointer-events: none;
}

.sala-agenda-dias--porta {
  display: flex;
  gap: clamp(3px, 0.9vw, 7px);
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.sala-agenda-dias--porta.sala-agenda-dias--diario {
  flex: 1 1 100%;
  min-width: 0;
  width: 100%;
  max-width: none;
}

.sala-agenda-dia--porta {
  min-width: 0;
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  gap: var(--sala-agenda-slot-gap);
  min-height: 0;
}

.sala-agenda-dia-cab--porta {
  height: var(--sala-agenda-cabeca-altura);
  min-height: var(--sala-agenda-cabeca-altura);
  flex-shrink: 0;
  margin-bottom: 0;
  padding: 4px 6px;
  box-sizing: border-box;
  background: linear-gradient(180deg,
      color-mix(in srgb, var(--cor-primaria-fraca) 95%, var(--cor-bg)) 0%,
      color-mix(in srgb, var(--cor-bg) 75%, var(--cor-primaria-fraca)) 100%);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 22%, var(--cor-separador));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1px;
  text-align: center;
}

.sala-agenda-dia-nome {
  font-size: clamp(0.65rem, 1.35vw, 0.8rem);
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--cor-primaria-forte);
}

.sala-agenda-dia-data {
  font-size: clamp(0.6rem, 1.2vw, 0.72rem);
  color: var(--cor-fonte-fraca);
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.sala-agenda-dia-cab--porta.sala-agenda-dia-cab--hoje {
  border-color: color-mix(in srgb, var(--cor-erro) 45%, var(--cor-separador));
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.5), 0 0 0 1px color-mix(in srgb, var(--cor-erro) 25%, transparent);
}

.sala-agenda-agora-linha {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 15;
  pointer-events: none;
  background: var(--cor-erro);
  border-radius: 1px;
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--cor-bg) 55%, transparent),
    0 0 10px color-mix(in srgb, var(--cor-erro) 45%, transparent);
  transform: translateY(-50%);
}

.sala-agenda-agora-marcador-leg {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  z-index: 3;
  pointer-events: none;
  background: var(--cor-erro);
  border-radius: 1px;
  box-shadow: 0 0 6px color-mix(in srgb, var(--cor-erro) 35%, transparent);
  transform: translateY(-50%);
}

.sala-agenda-dia-track--porta {
  position: relative;
  flex: 1;
  min-height: 0;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 18%, var(--cor-separador));
  background-color: var(--sala-agenda-coluna);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  background-image: repeating-linear-gradient(to bottom,
      transparent 0,
      transparent calc(100% / 10 - 1px),
      var(--sala-agenda-linha) calc(100% / 10 - 1px),
      var(--sala-agenda-linha) calc(100% / 10));
  background-size: 100% 100%;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.sala-agenda-bloco--porta {
  position: absolute;
  /* left/width definidos inline (layout lado a lado em conflitos) */
  z-index: 1;
  box-sizing: border-box;
  padding: 5px 7px;
  border-radius: 7px;
  font-size: clamp(0.6rem, 1.2vw, 0.78rem);
  line-height: 1.3;
  background: linear-gradient(145deg, var(--cor-bg) 0%, color-mix(in srgb, var(--cor-bg) 88%, var(--cor-primaria-fraca)) 100%);
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 22%, var(--cor-separador));
  border-left: 4px solid var(--cor-primaria);
  box-shadow: 0 3px 14px color-mix(in srgb, var(--cor-primaria-forte) 12%, transparent);
  color: var(--cor-fonte-forte);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  min-height: 0;
  cursor: pointer;
}

.sala-agenda-bloco--porta:focus-visible {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
  z-index: 2;
}

/* Reuniões curtas: pouca altura na grade — usa linha(s) na horizontal em vez de empilhar */
.sala-agenda-bloco--porta.sala-agenda-bloco--compacto {
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
  gap: 2px 8px;
  padding: 3px 6px;
  line-height: 1.2;
  font-size: clamp(0.58rem, 1.05vw, 0.74rem);
}

.sala-agenda-bloco--porta.sala-agenda-bloco--compacto .sala-agenda-bloco-hora {
  flex: 0 0 auto;
}

.sala-agenda-bloco--porta.sala-agenda-bloco--compacto .sala-agenda-bloco-org {
  margin-top: 0;
  flex: 0 0 auto;
}

.sala-agenda-bloco--porta.sala-agenda-bloco--compacto .sala-agenda-bloco-tit {
  flex: 1 1 120px;
  min-width: 0;
  -webkit-line-clamp: 2;
  line-clamp: 2;
}

/* ≤~24 min na faixa 8–18h: uma linha de texto quando couber */
.sala-agenda-bloco--porta.sala-agenda-bloco--micro {
  padding: 2px 5px;
  gap: 2px 6px;
  font-size: clamp(0.52rem, 0.95vw, 0.68rem);
}

.sala-agenda-bloco--porta.sala-agenda-bloco--micro .sala-agenda-bloco-tit {
  -webkit-line-clamp: 1;
  line-clamp: 1;
}

.sala-agenda-bloco--porta.sala-agenda-bloco--sala-recusou {
  z-index: 1;
  border-left-style: dashed;
  border-color: color-mix(in srgb, #c0392b 45%, var(--cor-separador));
  background:
    repeating-linear-gradient(
      -14deg,
      transparent 0,
      transparent 8px,
      color-mix(in srgb, #c0392b 07%, transparent) 8px,
      color-mix(in srgb, #c0392b 07%, transparent) 9px
    ),
    linear-gradient(145deg, var(--cor-bg) 0%, color-mix(in srgb, var(--cor-bg) 88%, var(--cor-primaria-fraca)) 100%);
  box-shadow: 0 2px 10px color-mix(in srgb, #c0392b 18%, transparent);
}

.sala-agenda-bloco--porta.sala-agenda-bloco--sala-recusou .sala-agenda-bloco-hora,
.sala-agenda-bloco--porta.sala-agenda-bloco--sala-recusou .sala-agenda-bloco-org,
.sala-agenda-bloco--porta.sala-agenda-bloco--sala-recusou .sala-agenda-bloco-tit {
  /* text-decoration: line-through; */
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
  text-decoration-color: color-mix(in srgb, #c0392b 65%, var(--cor-fonte-forte));
}

.sala-agenda-bloco-conflito-badge {
  align-self: flex-start;
  flex-shrink: 0;
  margin-bottom: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  background: color-mix(in srgb, #c0392b 92%, #000);
  text-decoration: none;
}

.sala-agenda-bloco--porta .sala-agenda-bloco-hora {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  color: var(--cor-primaria-forte);
  /* margin-bottom: 3px; */
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.sala-agenda-bloco--porta .sala-agenda-bloco-tit {
  font-weight: 600;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  word-break: break-word;
  hyphens: auto;
  min-height: 0;
  flex: 1 1 auto;
}

.sala-agenda-bloco--porta .sala-agenda-bloco-org {
  margin-top: 4px;
  flex-shrink: 0;
  font-size: .7rem;
  line-height: 1.25;
  color: var(--cor-fonte-fraca);
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  word-break: break-word;
}

.sala-agenda-bloco--porta .sala-agenda-bloco-loc {
  margin-top: 4px;
  font-size: 0.85em;
  color: var(--cor-fonte-fraca);
}

.sala-agenda-marca-hora {
  position: absolute;
  left: 0;
  right: 0;
  text-align: right;
  line-height: 1;
  transform: translateY(-50%);
  white-space: nowrap;
  font-variant-numeric: tabular-nums lining-nums;
}

.sala-agenda-marca-hora--inicio {
  /* 8:00: linha = bordo superior do track; texto logo abaixo */
  transform: translateY(0);
}

.sala-agenda-marca-hora--fim {
  /* 18:00: linha = bordo inferior */
  transform: translateY(-100%);
}

/* Modal detalhes do evento (Teleport → body) */
.sala-agenda-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(12px, 3vw, 28px);
  background: color-mix(in srgb, #0a1628 55%, transparent);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.sala-agenda-modal-sheet {
  width: min(520px, 100%);
  max-height: min(85vh, 640px);
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: var(--cor-bg);
  border: 1px solid color-mix(in srgb, var(--cor-primaria) 24%, var(--cor-separador));
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.35);
  color: var(--cor-fonte-forte);
  overflow: hidden;
}

.sala-agenda-modal-cab {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 12px;
  border-bottom: 1px solid color-mix(in srgb, var(--cor-primaria) 14%, var(--cor-separador));
}

.sala-agenda-modal-titulo {
  margin: 0;
  font-size: clamp(1.05rem, 2.2vw, 1.25rem);
  font-weight: 700;
  line-height: 1.25;
  word-break: break-word;
}

.sala-agenda-modal-btn-fechar {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  padding: 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: var(--cor-fonte-fraca);
  background: color-mix(in srgb, var(--cor-primaria) 8%, transparent);
}

.sala-agenda-modal-btn-fechar:hover {
  background: color-mix(in srgb, var(--cor-primaria) 16%, transparent);
  color: var(--cor-fonte-forte);
}

.sala-agenda-modal-btn-fechar:focus-visible {
  outline: 2px solid var(--cor-primaria);
  outline-offset: 2px;
}

.sala-agenda-modal-corpo {
  padding: 14px 18px 8px;
  overflow-y: auto;
  min-height: 0;
}

.sala-agenda-modal-alerta {
  margin: 0 0 12px;
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 0.88rem;
  background: color-mix(in srgb, #c0392b 12%, var(--cor-bg));
  border: 1px solid color-mix(in srgb, #c0392b 35%, transparent);
  color: var(--cor-fonte-forte);
}

.sala-agenda-modal-alerta .fas {
  margin-right: 8px;
  color: #c0392b;
}

.sala-agenda-modal-dl {
  margin: 0;
  display: grid;
  grid-template-columns: minmax(auto, 7.5rem) 1fr;
  gap: 8px 14px;
  font-size: 0.92rem;
}

.sala-agenda-modal-dl dt {
  margin: 0;
  font-weight: 600;
  color: var(--cor-fonte-fraca);
}

.sala-agenda-modal-dl dd {
  margin: 0;
  min-width: 0;
  word-break: break-word;
}

.sala-agenda-modal-desc {
  white-space: pre-wrap;
  font-size: 0.88rem;
  line-height: 1.45;
}

.sala-agenda-modal-participantes {
  margin: 0;
  padding-left: 1.35rem;
  list-style-type: decimal;
  list-style-position: outside;
}

.sala-agenda-modal-participantes li {
  margin-bottom: 6px;
  padding-left: 0.35rem;
}

.sala-agenda-modal-part-linha {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.sala-agenda-modal-part-nome {
  min-width: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sala-agenda-modal-part-linha .chip {
  flex-shrink: 0;
  margin-left: 0;
  vertical-align: middle;
}

.sala-agenda-modal-acoes {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid color-mix(in srgb, var(--cor-primaria) 12%, var(--cor-separador));
}

.sala-agenda-modal-link {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--cor-primaria-forte);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.sala-agenda-modal-rodape {
  margin: 0;
  padding: 10px 18px 14px;
  font-size: 0.75rem;
  color: var(--cor-fonte-fraca);
  border-top: 1px solid color-mix(in srgb, var(--cor-primaria) 10%, var(--cor-separador));
}
</style>

<style>
html.sala-porta-html {
  background-color: color-mix(in srgb, var(--cor-primaria) 6%, var(--cor-bg));
  background-image: radial-gradient(ellipse 95% 70% at 0% 0%,
      color-mix(in srgb, var(--cor-primaria) 24%, transparent) 0%,
      transparent 55%),
    radial-gradient(ellipse 60% 45% at 100% 8%, color-mix(in srgb, var(--cor-primaria-media) 100%, transparent) 0%, transparent 52%),
    linear-gradient(168deg,
      var(--cor-bg) 0%,
      color-mix(in srgb, var(--cor-primaria-fraca) 50%, var(--cor-bg)) 42%,
      color-mix(in srgb, var(--cor-primaria) 9%, #f3f6fc) 100%),
    url("~@/assets/img/grafismo2.svg");
  background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  background-position: 0 0, 100% 0, 0 0, center bottom;
  background-size: 100% 100%, 100% 100%, 100% 100%, cover;
  background-attachment: fixed;
}

html.dark.sala-porta-html .sala-agenda-view--porta {
  background-color: var(--cor-bg);
  background-image: linear-gradient(165deg,
      color-mix(in srgb, var(--cor-primaria-forte) 14%, var(--cor-bg)) 0%,
      var(--cor-bg) 50%,
      color-mix(in srgb, var(--cor-primaria-fraca) 40%, #0a0c0e) 100%),
    url("~@/assets/img/grafismo2-dark.svg");
  background-repeat: no-repeat, no-repeat;
  background-position: 0 0, center bottom;
  background-size: 100% 100%, cover;
}

html.dark.sala-porta-html .sala-agenda-surface::before {
  opacity: 0.14;
  filter: brightness(1.15);
}

html.dark.sala-porta-html .sala-agenda-surface {
  background: linear-gradient(145deg,
      color-mix(in srgb, var(--cor-primaria-forte) 22%, rgba(20, 24, 30, 0.85)) 0%,
      rgba(24, 28, 34, 0.55) 100%);
  border-color: color-mix(in srgb, var(--cor-primaria) 35%, rgba(255, 255, 255, 0.12));
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(16px) saturate(1.2);
  -webkit-backdrop-filter: blur(16px) saturate(1.2);
}
</style>
